
export const UserScore = ({ score }) => {

    return (
        <div className="box user_count_box">
            <div className="countRow">
                <div className="count"><i className="fa-solid fa-right-to-bracket"></i><p>출석</p><p className="count_number">{score?.loginDays}</p></div>
                <div className="count"><i className="fa-solid fa-comment"></i><p>댓글</p><p className="count_number">{score?.commentCount}</p></div>
                <div className="count"><i className="fa-solid fa-thumbs-up"></i><p>좋아요/받은좋아요</p><p className="count_number">{score?.likeGiveCount}/{score?.likeCount}</p></div>
                <div className="count"><i className="fa-solid fa-circle-question"></i><p>독서퀴즈</p><p className="count_number">{score?.quizCount}</p></div>

                <div className="count"><i className="fa-solid fa-pencil"></i><p>독서감상문</p><p className="count_number">{score?.reportCount}</p></div>
                <div className="count"><i className="fa-solid fa-palette"></i><p>독서화</p><p className="count_number">{score?.pictureCount}</p></div>
                <div className="count"><i className="fa-solid fa-camera"></i><p>독서사진</p><p className="count_number">{score?.photoCount}</p></div>
                <div className="count"><i className="fa-brands fa-youtube"></i><p>독서영상</p><p className="count_number">{score?.youtubeCount}</p></div>

                <div className="count"><i className="fa-solid fa-handshake-simple"></i><p>책이랑 나랑</p><p className="count_number">{score?.meetingCount}</p></div>
                <div className="count"><i className="fa-solid fa-comments"></i><p>독서토론</p><p className="count_number">{score?.debateCount}</p></div>
                <div className="count"><i className="fa-solid fa-crown"></i><p>질문왕</p><p className="count_number">{score?.bestMeetingCount}</p></div>
                <div className="count"><i className="fa-solid fa-pen-fancy"></i><p>나도작가다</p><p className="count_number">{score?.userbookCount}</p></div>

            </div>

            <div className="apple_girl"><img src={`${process.env.PUBLIC_URL}/static/images/user/apple_girl.png`} alt="" /></div>
            <div className="apple_boy"><img src={`${process.env.PUBLIC_URL}/static/images/user/apple_boy.png`} alt="" /></div>
        </div>
    )
};